module.exports = __webpack_public_path__ + "static/media/check_with_bg_pink.e7f844fd.svg";